import api from '../config/api';
import {
  FETCH_RESERVATION_LOADING,
  FETCH_RESERVATION_SUCCESS,
  FETCH_RESERVATION_ERROR,
  DELETE_RESERVATION_ERROR,
  DELETE_RESERVATION_LOADING,
  DELETE_RESERVATION_SUCCESS,
  FETCH_RESERVATION_FLOOR_SUCCESS,
  FETCH_RESERVATION_FLOOR_ERROR,
  FETCH_OPERATION_SUCCESS,
  FETCH_OPERATION_LOADING,
  FETCH_OPERATION_ERROR,
  FETCH_RESERVATION_FLOOR_LOADING,
  FETCH_OPERATIONS_BY_DEPARTMENT_LOADING,
  FETCH_OPERATIONS_BY_DEPARTMENT_SUCCESS,
  FETCH_OPERATIONS_BY_DEPARTMENT_ERROR,
  FETCH_DEPARTMENT_OPERATIONS_SUCCESS,
  FETCH_DEPARTMENT_OPERATIONS_LOADING,
  FETCH_DEPARTMENT_OPERATIONS_ERROR,
  DELETE_MULTIPLE_RESERVATIONS_LOADING,
  DELETE_MULTIPLE_RESERVATIONS_SUCCESS,
  DELETE_MULTIPLE_RESERVATIONS_ERROR
} from '../Types/operationTypes';
import { Encrypt } from './Crypto';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchUsersReservations = (start: string, end: string) => {
  return dispatch => {
    dispatch({ type: FETCH_RESERVATION_LOADING });
    api
      .get(`${API_URL}Operation/getReservations/${start}/${end}`)
      .then(response => {
        const reservations = response.data.data;
        dispatch({
          type: FETCH_RESERVATION_SUCCESS,
          payload: reservations
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_RESERVATION_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const fetchFloorReservations = (floorId: string, startDate, endDate) => {
  return dispatch => {
    dispatch({ type: FETCH_RESERVATION_FLOOR_LOADING });

    api
      .get(`${API_URL}Operation/getReservationByFloor/${floorId}/${startDate}/${endDate}`)
      .then(response => {
        const reservations = response.data;
        dispatch({
          type: FETCH_RESERVATION_FLOOR_SUCCESS,
          payload: reservations
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_RESERVATION_FLOOR_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const deleteReservation = (id: string) => {
  return dispatch => {
    dispatch({ type: DELETE_RESERVATION_LOADING });
    return api
      .delete(`${API_URL}Operation/deleteReservation/${id}`)
      .then(response => {
        dispatch({
          type: DELETE_RESERVATION_SUCCESS,
          payload: id
        });
        return response;
      })
      .catch(error => {
        const errorMsg = error.response?.data?.message || error.message;
        dispatch({
          type: DELETE_RESERVATION_ERROR,
          payload: errorMsg
        });
        throw error;
      });
  };
};
export const deleteMultipleReservations = (ids: string[]) => {
  return dispatch => {
    dispatch({ type: DELETE_MULTIPLE_RESERVATIONS_LOADING });
    return api
      .delete(`${API_URL}Operation/deleteMultipleReservations`, {
        data: { ids }
      })
      .then(response => {
        dispatch({
          type: DELETE_MULTIPLE_RESERVATIONS_SUCCESS,
          payload: ids
        });
        return response;
      })
      .catch(error => {
        const errorMsg = error.response?.data?.message || error.message;
        dispatch({
          type: DELETE_MULTIPLE_RESERVATIONS_ERROR,
          payload: errorMsg
        });
        throw error;
      });
  };
};
export const deleteOperation = async id => {
  const result = await api
    .delete(`${API_URL}Operation/deleteOperation/${id}`)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      const errorMsg = error.message;
      return errorMsg;
    });

  return result;
};

// export const deleteOperation = (id: string) => {
//   return dispatch => {
//     dispatch({ type: DELETE_OPERATION_LOADING });
//     return api
//       .delete(`${API_URL}Operation/deleteOperation/${id}`)
//       .then(response => {
//         dispatch({
//           type: DELETE_OPERATION_SUCCESS,
//           payload: id
//         });
//         return response;
//       })
//       .catch(error => {
//         const errorMsg = error.message;
//         dispatch({
//           type: DELETE_OPERATION_ERROR,
//           payload: errorMsg
//         });
//         throw error;
//       });
//   };
// };

export const getOperationsByUsers = (users, startDate, endDate) => {
  return dispatch => {
    dispatch({ type: FETCH_OPERATION_LOADING });
    api
      .post(`${API_URL}Operation/getOperations`, {
        users: users,
        startDate: startDate,
        endDate: endDate
      })
      .then(response => {
        const data = response.data.data;
        dispatch({
          type: FETCH_OPERATION_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_OPERATION_ERROR,
          payload: errorMsg
        });
      });
  };
};
export const fetchDepartmentOperations = (start: string, end: string) => {
  return dispatch => {
    dispatch({ type: FETCH_DEPARTMENT_OPERATIONS_LOADING });
    api
      .get(`${API_URL}Operation/operationByDepartement/${start}/${end}`)
      .then(response => {
        dispatch({
          type: FETCH_DEPARTMENT_OPERATIONS_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_OPERATION_ERROR,
          type: FETCH_DEPARTMENT_OPERATIONS_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const getOperationsByDepartments = (departments, startDate, endDate) => {
  return dispatch => {
    dispatch({ type: FETCH_OPERATION_LOADING });
    api
      .post(`${API_URL}Operation/getOperationsByDepartment`, {
        departments: departments,
        startDate: startDate,
        endDate: endDate
      })
      .then(response => {
        const data = response.data.data;
        dispatch({
          type: FETCH_OPERATION_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_OPERATION_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const deleteAdminOperation = (id: string) => {
  return dispatch => {
    dispatch({ type: DELETE_RESERVATION_LOADING });
    return new Promise((resolve, reject) => {
      api
        .delete(`${API_URL}Operation/deleteAdminOperation/${id}`)
        .then(response => {
          dispatch({
            type: DELETE_RESERVATION_SUCCESS,
            payload: id
          });
          resolve(response);
        })
        .catch(error => {
          const errorMsg = error.response?.data?.message || error.message;
          dispatch({
            type: DELETE_RESERVATION_ERROR,
            payload: errorMsg
          });
          reject(error);
        });
    });
  };
};

export const getRoomsOperations = (rooms, date) => {
  return dispatch => {
    dispatch({ type: FETCH_OPERATION_LOADING });
    api
      .post(`${API_URL}Operation/getRoomsOperations?date=${date}`, rooms)
      .then(response => {
        const data = response.data.data;
        dispatch({
          type: FETCH_OPERATION_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_OPERATION_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const addRoomReservation = async reservation => {
  const result = await api
    .post(`${API_URL}Operation/addRoomReservation/`, reservation)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.log(error);
      const errorMsg = error.message;
      return errorMsg;
    });

  return result;
};

export const addGuestReservation = async reservation => {
  const data = Encrypt(reservation);
  const result = await api
    .post(process.env.REACT_APP_API_URL + `Operation/addGuestReservation`, {
      data: data
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      const errorMsg = error.message;
      return errorMsg;
    });

  return result;
};

export const deleteResourceReservation = data => {
  return dispatch => {
    dispatch({ type: DELETE_RESERVATION_LOADING });
    return api
      .post(`${API_URL}Operation/deleteAdminReservation`, data)
      .then(response => {
        dispatch({
          type: DELETE_RESERVATION_SUCCESS
        });
        return response;
      })
      .catch(error => {
        const errorMsg = error.response?.data?.message || error.message;
        dispatch({
          type: DELETE_RESERVATION_ERROR,
          payload: errorMsg
        });
        throw error;
      });
  };
};
